module.exports = __webpack_public_path__ + "static/media/reportingUp.a078abcb.svg";